<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <h1>AdRoll</h1>
        <p>
          AdRoll Pixel
        </p>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="4">
        <!-- <h3>AdRoll Pixel</h3>
        <p>
          AdRoll Pixel
        </p> -->
      </v-col>
      <v-col cols="12" md="8">
        <v-row v-for="(item, ind) in adrollPixel" :key="ind">
          <v-col md="5" cols="5" class="py-0 mb-2">
            <h3>AdRoll Advertiser ID</h3>
            <v-text-field hide-details="" v-model="item.adroll_adv_id"></v-text-field>
          </v-col>
          <v-col md="5" cols="5" class="py-0 mb-2">
            <h3>AdRoll Pixel ID</h3>
            <v-text-field hide-details="" v-model="item.adroll_pix_id"></v-text-field>
          </v-col>
          <v-col v-if="ind > 0" class="pt-1 d-flex align-end" cols="2">
            <v-btn class="delete-btn" color="primary" outlined @click="reduceOption(ind)">
              <v-icon>mdi mdi-delete mdi-18px</v-icon>
            </v-btn>
          </v-col>
          <v-col
            v-if="!item.adroll_adv_id || !item.adroll_pix_id"
            md="12"
            cols="12"
            class="pb-0 pt-0 mb-2"
            style="line-height: 12px;word-break: break-word;color: red; font-size: 12px"
          >
            Please fill in both Advertiser ID and Pixel ID.
          </v-col>
        </v-row>
        <v-row>
          <v-col class="" md="2" sm="2">
            <v-btn class="pt-0" color="primary" @click="addOption">+ Add more</v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    adrollPixel: {
      type: Array,
      required: true,
    },
  },
  methods: {
    reduceOption(index) {
      this.$emit('removeAdRollPixel', index);
    },
    addOption() {
      this.$emit('addAdRollPixel');
    },
  },
};
</script>
